export default __webpack_public_path__ + "static/media/SurfaceDuo.a0a09d08.svg";